
import axiosClient from "./axiosClient";

const serviceUrl = '/core-manager';

const sharedDirectory = {
    getListProvince: async (page = 1, limit = 100) => {
        const url = serviceUrl + `/province/list-province`;
        const response = await axiosClient.get(url, {
          page: page, 
          limit: limit
        });
        return response;
    },
    getListDistrict: async (params) => {
      const url = serviceUrl + `/district/provinceId?provinceId=${params.provinceId}`;
      const response = await axiosClient.get(url)
      return response;
    },
    getListCommune: async (params) => {
      const url = serviceUrl + `/commune/districtId?districtId=${params.districtId}`;
      const response = await axiosClient.get(url)
      return response;
    },
    getListNation: async (params) => {
      const url = serviceUrl + `/nation/list-nation`;
      const response = await axiosClient.get(url, {params: params})
      return response;
    },
    getListDanToc: async (params) => {
      const url = serviceUrl + `/dan-toc/list-dan-toc`;
      const response = await axiosClient.get(url, {params: params})
      return response;
    },
    getListTonGiao: async (params) => {
      const url = serviceUrl + `/ton-giao/list-ton-giao`;
      const response = await axiosClient.get(url, {params: params})
      return response;
    },
    searchCommune: async (params) => {
      const url = serviceUrl + `/commune/name`;
      const response = await axiosClient.get(url, {params: params})
      return response.data;
    },
    getAddressByCommune: async (params) => {
      const url = serviceUrl + `/commune/id`;
      const response = await axiosClient.get(url, {params: params})
      return response.data;
    }
};

export default sharedDirectory;
